export enum MapSizeTypes {
    ENLARGE = 'enlarge',
    REDUCE = 'reduce',

}
